import axios from 'axios'

// URL base dell'API per i comuni, recuperato dall'env file
const COMUNE_REST_API_URL = process.env.REACT_APP_API_PREFIX + 'comune'

const headers = { 'Content-Type': 'application/json' }

class ComuneService {
    /**
     * Recupera un comune specifico in base al suo ID.
     * Effettua una richiesta GET a `/comune/{id}`.
     *
     * @param {number} id - L'ID del comune da recuperare.
     * @returns {Promise} - Una promessa che restituisce i dettagli del comune.
     */
    getComune(id) {
        return axios.get(COMUNE_REST_API_URL + `/${id}`)
    }

    /**
     * Salva o aggiorna un comune nel sistema.
     * Effettua una richiesta POST a `/comune/save` con i dati del comune.
     *
     * @param {Object} comune - Oggetto contenente i dettagli del comune da salvare.
     * @returns {Promise} - Una promessa che restituisce la risposta del server dopo il salvataggio.
     */
    aggiornaComune(comune){
        return axios.post(COMUNE_REST_API_URL + "/save", comune, headers)
    }

    /**
     * Recupera i dati dell'header del comune.
     * Effettua una richiesta GET a `/comune/header` per ottenere le informazioni necessarie.
     * Ottenere il comune in produzione
     * @returns {Promise} - Una promessa che restituisce i dati dell'header del comune.
     */
    header(){
        return axios.get(COMUNE_REST_API_URL + "/header")
    }

   



}

// Creazione dell'istanza per essere importata direttamente nei componenti
const comuneServiceInstance = new ComuneService()
export default comuneServiceInstance;